import { LeihBarPermissions } from '@thro-types/access-handler';

import { Route, Routes } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';

import { DailyOrderDetail } from './OrderDetail';
import { DailyOverview } from './Overview';

export const Daily = ({ currentUser, userPermission }) => {
  return (
    <Routes>
      <Route
        index
        element={
          <PrivateRoute
            user={currentUser}
            userPermissions={userPermission}
            requiredPermission={LeihBarPermissions.LEIHBAR_PRODUCT_CREATE}
          >
            <DailyOverview />
          </PrivateRoute>
        }
      />
      <Route
        path=":id"
        element={
          <PrivateRoute
            user={currentUser}
            userPermissions={userPermission}
            requiredPermission={LeihBarPermissions.LEIHBAR_PRODUCT_CREATE}
          >
            <DailyOrderDetail />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
